<script setup lang="ts">
import { Filter } from '@/types'
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuCheckboxItem,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { ChevronDown } from 'lucide-vue-next'

const props = defineProps<{
    value: string[]
    options: Filter[]
    show: boolean
    buttonLabel?: string
    optionsLabel?: string
}>()

const emit = defineEmits(['update:value'])

const isChecked = (optionValue: string) => props.value.includes(optionValue)

const onCheckedChange = (optionValue: string, checked: boolean) => {
    const updatedValue = [...props.value]

    if (checked) {
        updatedValue.push(optionValue)
    } else {
        updatedValue.splice(updatedValue.indexOf(optionValue), 1)
    }

    emit('update:value', updatedValue)
}
</script>

<template>
    <div v-if="props.show">
        <DropdownMenu>
            <DropdownMenuTrigger as-child>
                <Button
                    variant="outline"
                    size="sm"
                    class="w-48 justify-between text-muted-foreground"
                >
                    <span>{{ props.buttonLabel }}</span>
                    <ChevronDown class="size-4 ml-2" />
                </Button>
            </DropdownMenuTrigger>

            <DropdownMenuContent class="w-56" align="end">
                <DropdownMenuLabel>{{ props.optionsLabel }}</DropdownMenuLabel>

                <DropdownMenuCheckboxItem
                    v-for="option in options"
                    :key="option.value"
                    :model-value="isChecked(option.value)"
                    @update:model-value="onCheckedChange(option.value, $event as boolean)"
                >
                    {{ option.label }}
                </DropdownMenuCheckboxItem>
            </DropdownMenuContent>
        </DropdownMenu>
    </div>
</template>
